import { render, staticRenderFns } from "./queryAgree.vue?vue&type=template&id=59c1a320"
import script from "./queryAgree.vue?vue&type=script&lang=js"
export * from "./queryAgree.vue?vue&type=script&lang=js"
import style0 from "./queryAgree.vue?vue&type=style&index=0&id=59c1a320&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports